export default __webpack_public_path__ + "static/media/SeminarioIes2026_RaquelQuevedo.0ab7530a.jpg";